export default __webpack_public_path__ + "static/media/example_avater.9dfdc940.svg";